var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.placementevents.length)?_vm._l((_vm.placementevents),function(placement){return _c('div',{key:placement.id},[_c('PlacementEventsListItem',{attrs:{"placement":placement},on:{"newMessageCallback":_vm.newMessage}})],1)}):_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.$t('no-results')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }